import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const invalidStyle = {
    borderColor: 'var(--err)',
    boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.15)',
};
const monoStyle = {
    fontFamily: 'var(--font-mono)',
    fontSize: 12,
};
/** Canonical text input — wraps `.input` from shell.css. */
export const Input = forwardRef(function Input({ invalid, mono, className = '', style, ...rest }, ref) {
    return (_jsx("input", { ref: ref, className: `input${className ? ` ${className}` : ''}`, style: {
            ...(mono ? monoStyle : null),
            ...(invalid ? invalidStyle : null),
            ...style,
        }, ...rest }));
});
export const Textarea = forwardRef(function Textarea({ invalid, mono, className = '', style, ...rest }, ref) {
    return (_jsx("textarea", { ref: ref, className: `input${className ? ` ${className}` : ''}`, style: {
            ...(mono ? monoStyle : null),
            ...(invalid ? invalidStyle : null),
            ...style,
        }, ...rest }));
});
export const Select = forwardRef(function Select({ invalid, className = '', children, style, ...rest }, ref) {
    return (_jsx("select", { ref: ref, className: `input${className ? ` ${className}` : ''}`, style: {
            appearance: 'none',
            paddingRight: 28,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 8px center',
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%238a91a0' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\")",
            ...(invalid ? invalidStyle : null),
            ...style,
        }, ...rest, children: children }));
});
//# sourceMappingURL=Input.js.map